import "./AreasCovered.module.css";
import Header from "@/reusable_sections/Header";
import ServingNorfolkBeyond from "./sections/ServingNorfolkBeyond";
import TownsWeFrequentlyVisit from "./sections/TownsWeFrequentlyVisit";
import CheckYourLocation from "./sections/CheckYourLocation";
import Footer from "@/reusable_sections/Footer";
export default function AreasCoveredPage() {
  return <div>
      <Header />
      <ServingNorfolkBeyond />
      <TownsWeFrequentlyVisit />
      <CheckYourLocation />
      <Footer />
    </div>;
}